import React from 'react';
import GetSvg from '../../vendor/GetSvg';

const StatusLevel = ({ name }) => (
  <div className="status-level">
    <div className="status-level__icon">
      <GetSvg svg="status_level" wrapperClass="svg status-level__icon-art" />
    </div>
    <div className="status-level__name">{name}</div>
    <div className="status-level__label">
      Status
      <br />
      Level
    </div>
  </div>
);

export default StatusLevel;
